import React, {Component, Fragment} from 'react';
import {Row, Col} from 'reactstrap';
import DepositsChart from '../../../../containers/DepositsChart';
import WithdrawsChart from '../../../../containers/WithdrawsChart';
import TradesChart from '../../../../containers/TradesChart';
import DoughnutChartCard from '../../../../components/DoughnutChartCard';
import UsersDistributionByWalletBalance from '../../../../containers/UsersDistributionByWalletBalance';
import HorizontalBarChartComponent from '../../../../components/HorizontalBarChartCard';
import {withTranslation} from 'react-i18next';
import Api from '../../../../services/Api';
import {values, keys} from 'lodash';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';

class All extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: null,
    };
    this.barCharts = [
      {type: 'activeTraderUsersCount', title: props.t('Active Users Count')},
      {type: 'submittedKycCount', title: props.t('Submitted KYC Count')},
      {type: 'identityVerifiedUsersCount', title: props.t('Identity Verified Users Count')},
      {type: 'activeLoggedInUsersCount', title: props.t('Active Logged In Users Count')},
      {type: 'inExchangeRegisteredUsersCount', title: props.t('In Exchange Registered Users Count')},
      {type: 'thirdPartyApiRegisteredUsersCount', title: props.t('Third Party Api Registered Users Count')},
      {type: 'registeredUsersByReferralTokenCount', title: props.t('Registered Users By Referral Token Count')},
    ];
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke(
        'GET',
        '/admin-ui/private-statistics',
        null,
        {
          cancelToken: null,
        }
      );
      this.setState({statistics: data});
    } catch (e) {
      console.log('error: ', e);
    }
  };

  render() {
    const {t} = this.props;
    const {statistics} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={this.props.match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <UsersDistributionByWalletBalance />
        <Row>
          <Col className='col-12 col-lg-6'>
            <DoughnutChartCard
              title={t('Users distribution by kyc level')}
              labels={statistics ? keys(statistics.usersKycLevelCount).map((_, index) => t('level {{number}}', {number: index + 1})) : null}
              data={statistics ? values(statistics.usersKycLevelCount) : null}
            />
          </Col>
          {this.barCharts.map((item, index) => (
            <Col key={index} className='col-12 col-lg-6'>
              <HorizontalBarChartComponent
                title={item.title}
                labels={statistics ? keys(statistics[item.type]).map(label => t(label)) : null}
                data={statistics ? values(statistics[item.type]): null}
              />
            </Col>
          ))}
          {/*<Col className='col-12 col-lg-6'>*/}
          {/*  <DoughnutChartCard*/}
          {/*    title={t('User distribution by loyalty level')}*/}
          {/*    labels={statistics ? keys(statistics.usersLoyaltyLevelCount).map((_, index) => t('level {{number}}', {number: index + 1})) : null}*/}
          {/*    data={statistics ? values(statistics.usersLoyaltyLevelCount) : null}*/}
          {/*  />*/}
          {/*</Col>*/}
        </Row>
        {/*<Row>*/}
        {/*  {this.barCharts.map((item, index) => (*/}
        {/*    <Col key={index} className='col-12 col-lg-6'>*/}
        {/*      <HorizontalBarChartComponent*/}
        {/*        title={item.title}*/}
        {/*        labels={statistics ? keys(statistics[item.type]).map(label => t(label)) : null}*/}
        {/*        data={statistics ? values(statistics[item.type]): null}*/}
        {/*      />*/}
        {/*    </Col>*/}
        {/*  ))}*/}
        {/*</Row>*/}
        <TradesChart />
        <DepositsChart />
        <WithdrawsChart />
      </Fragment>
    );
  }
}

export default withTranslation()(All);
